import { FC } from 'react';

import { Button, Modal } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import HtmlContent from '@telialt/common-html-content/src';
import { ProductImageData } from '@telialt/models/src/EshopModel';

import { Z_INDEX_MODAL } from '../../../constants/constants';
import { ESimModalBody, ESimModalImage } from './ESimInfoModal.styles';
import { ESIM_CARD_TEST_ID } from './test-ids';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    description: string;
    image?: ProductImageData;
    imagePosition?: 'LEFT' | 'TOP';
};

export const ESimInfoModal: FC<Props> = ({ isOpen, onClose, title, description, image, imagePosition }) => {
    const { t } = useTranslations();

    const isHorizontal = imagePosition === 'LEFT';
    const hasImage = !!image?.url;
    const body = <HtmlContent content={description} />;

    return (
        <Modal open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <Modal.Content
                title={title}
                actions={
                    <Button variant="primary" onClick={onClose} data-test={ESIM_CARD_TEST_ID.MODAL_CLOSE}>
                        {t['common.button.close']}
                    </Button>
                }
                stickyButtons={true}
                image={
                    !isHorizontal &&
                    hasImage && (
                        <img src={image?.url} alt={image?.altText ?? ''} data-test={ESIM_CARD_TEST_ID.MODAL_IMAGE} />
                    )
                }
                showCloseButton={true}
                closeButtonAriaLabel={t['common.button.close']}
                zIndex={Z_INDEX_MODAL}
                data-test={ESIM_CARD_TEST_ID.MODAL}
            >
                {isHorizontal && hasImage ? (
                    <ESimModalBody>
                        <ESimModalImage
                            src={image?.url}
                            alt={image?.altText ?? ''}
                            data-test={ESIM_CARD_TEST_ID.MODAL_IMAGE}
                        />
                        {body}
                    </ESimModalBody>
                ) : (
                    body
                )}
            </Modal.Content>
        </Modal>
    );
};
